/**
 * Configuration constants for Dynamic Properties feature
 */

// API Endpoints
export const API_ENDPOINTS = {
  GET_BY_KEYS: "/sapna/dynamicProperties/get-by-keys",
  CREATE: "/sapna/dynamicProperties/create",
  UPDATE: "/sapna/dynamicProperties/update",
};

// Meta Key
export const META_KEY = "dynamic.properties.list";

// Validation Constants
export const VALIDATION = {
  KEY_MAX_LENGTH: 50,
  MIN_JSON_OBJECT_KEYS: 0,
};

// Pagination Defaults
export const PAGINATION = {
  DEFAULT_ROWS_PER_PAGE: 10,
  ROWS_PER_PAGE_OPTIONS: [5, 10, 25, 50],
};

// Sort Directions
export const SORT_DIRECTION = {
  ASC: "asc",
  DESC: "desc",
};

// Default Sort Config
export const DEFAULT_SORT_CONFIG = {
  key: null,
  direction: SORT_DIRECTION.ASC,
};

// View Modes
export const VIEW_MODE = {
  FORM: "form",
  JSON: "json",
};

// Default View Mode
export const DEFAULT_VIEW_MODE = VIEW_MODE.FORM;

// Snackbar Configuration
export const SNACKBAR = {
  AUTO_HIDE_DURATION: 3000,
  SEVERITY: {
    SUCCESS: "success",
    ERROR: "error",
  },
};

// Success Messages
export const MESSAGES = {
  CREATE_SUCCESS: "Dynamic Property Created Successfully",
  UPDATE_SUCCESS: "Dynamic Property Updated Successfully",
  DELETE_SUCCESS: "Dynamic Property Deleted Successfully",
  GENERIC_ERROR: "An error occurred. Please try again.",
  NO_PROPERTIES: "No dynamic properties found. Create a new one to get started.",
  NO_SEARCH_RESULTS: "No properties match your search criteria.",
  INVALID_JSON: "Invalid JSON format",
  EMPTY_JSON: "JSON object cannot be empty",
  KEY_REQUIRED: "Key is required",
  KEY_TOO_LONG: `Key must be ${VALIDATION.KEY_MAX_LENGTH} characters or less`,
  VALIDATION_ISSUES:
    "There are validation issues. Please review the messages below and fix them before saving.",
};

// Search Configuration
export const SEARCH = {
  SEARCHABLE_FIELDS: ["key", "createdBy", "updatedBy"],
};

// Table Configuration
export const TABLE = {
  COLUMN_WIDTHS: {
    KEY: "200px",
    CREATED_BY: "250px",
    CREATED_AT: "150px",
    UPDATED_BY: "250px",
    UPDATED_AT: "150px",
  },
};

// Date Format
export const DATE_FORMAT = {
  DISPLAY: "YYYY-MM-DD HH:mm:ss",
  ISO_REPLACE: " ", // Space to replace with 'T' for ISO format
  ISO_REPLACEMENT: "T",
};

// Form Configuration
export const FORM = {
  JSON_EDITOR_MIN_HEIGHT: 400,
  SCHEMA_DISPLAY_MAX_HEIGHT: 200,
};

// Route Paths
export const ROUTES = {
  LIST: "/dynamic-properties",
  CREATE: "/dynamic-properties/create",
  EDIT: (key) => `/dynamic-properties/edit/${encodeURIComponent(key)}`,
};

// State Keys
export const STATE_KEYS = {
  DUPLICATED_DATA: "duplicatedData",
};

// Data Types
export const DATA_TYPES = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  OBJECT: "object",
  ARRAY: "array",
};

// Data Type Options for Select Menus
export const DATA_TYPE_OPTIONS = [
  { value: DATA_TYPES.STRING, label: "String" },
  { value: DATA_TYPES.NUMBER, label: "Number" },
  { value: DATA_TYPES.BOOLEAN, label: "Boolean" },
  { value: DATA_TYPES.OBJECT, label: "Object" },
  { value: DATA_TYPES.ARRAY, label: "Array" },
];

// Default Data Type
export const DEFAULT_DATA_TYPE = DATA_TYPES.STRING;
